<template>
  <div class="saas">
    <div class="screen screen01">
      <img src="./resources/screen01.jpg" alt="img" />
    </div>
    <div class="mask" v-show="show" @click="() => (show = false)">
      <div class="box">
        <i class="el-icon-top-right" />
        <span>请点击右上角的按钮，选择浏览器打开...</span>
      </div>
    </div>
    <div :class="`app-lists${isMobile ? '-mobile' : ''}`">
      <div class="app" v-for="(list, i) in lists" :key="i">
        <img class="icon" :src="list.icon || require('@/images/default.png')" alt="icon" />
        <a href="javascript:;" @click="onClick(list.arduino)">{{ list.name }}</a>
        <div class="btn-group">
          <Button v-show="!(isMobile && isMobile[0] === 'iPhone')" class="btn" type="info" :size="isMobile ? 'mini' : 'small'" @click="onClick(list.arduino)">下载 APK</Button>
          <Button v-show="!(isMobile && isMobile[0] === 'Android')" type="info" :size="isMobile ? 'mini' : 'small'" @click="onClick(list.ios)">跳转 App Store</Button>
        </div>
        <div class="description">
          <span>{{ list.description.split('\\n')[0] }}</span>
          <span>{{ list.description.split('\\n')[1] }}</span>
        </div>
      </div>
    </div>
    <div class="screen screen03">
      <img src="./resources/screen03.jpg" alt="img" />
      <div class="box">
        <div class="desc right">
          <p><i />APP</p>
          <p><i />免费公版APP,即刻使用</p>
          <p><i />OEM品牌专属APP，快速上线，专人培训</p>
          <p><i />提供总部智能展厅配置方案，辅导智能化落地推广</p>
        </div>
        <div class="desc left">
          <p>H5<i /></p>
          <p>天猫精灵、小米IoT、华为云设备控制H5设计开发<i /></p>
          <p>公版免费使用，推荐驱动电源及控制板厂商资源<i /></p>
          <p>支持品牌定制，快速上线，免费送样<i /></p>
        </div>
      </div>
    </div>
    <div class="screen screen04">
      <img src="./resources/screen04.jpg" alt="img" />
      <div class="box">
        <h1>定制自己品牌APP</h1>
        <div class="b b00">
          <p><img src="./resources/icon00.jpg" /> 高效便捷</p>
          <p>1天开发完成，拥有le+pro公版APP标准功能；</p>
        </div>
        <div class="b b01">
          <p><img src="./resources/icon01.jpg" /> 低成本</p>
          <p>无需服务器开发，无需搭建团队，标准服务</p>
        </div>
        <div class="b b02">
          <p><img src="./resources/icon02.jpg" /> 配套落地服务</p>
          <p>线下系统培训指导，提供智能展厅配置方案；开放工厂供应链</p>
        </div>
        <div class="b b03">
          <p><img src="./resources/icon03.jpg" /> 一站式服务</p>
          <p>全程项目经理指导，客户只需提交企业资料即可完成苹果及安卓系统</p>
        </div>
      </div>
    </div>
    <div class="screen screen05">
      <div class="title">
        <h1 class="tit">定制品牌 H5</h1>
        <h4 class="subtitle">提供配套物联模组及控制电器厂商资源，可快速量产</h4>
      </div>
      <div class="cases">
        <Carousel indicator-position="outside" :height="`${(bodyWidth / 5) * (1350 / 650)}px`">
          <CarouselItem v-for="j in Math.ceil(cases.length / 4)" :key="j">
            <div class="scre" v-if="j < Math.ceil(cases.length / 4)">
              <div class="case" v-for="i in 4" :key="i">
                <img :src="cases[(j - 1) * 4 + (i - 1)]" alt="1" />
              </div>
            </div>
            <div class="scre" v-else>
              <div class="case" v-for="i in cases.length % 4" :key="i">
                <img :src="cases[(j - 1) * 4 + (i - 1)]" alt="1" />
              </div>
            </div>
          </CarouselItem>
        </Carousel>
      </div>
      <div class="descs">
        <div class="desc" v-for="(item, k) in screen05" :key="k">
          <span class="tit" v-text="item.title" />
          <span class="des" v-html="item.subtitle" />
          <Button class="btn" type="info">立即定制</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { _isMobile, _isWeChat } from '@/utils/config';
import { getAppLists } from '@/utils/service';
import { Button } from 'vant';
import { Carousel, CarouselItem } from 'element-ui';

export default {
  metaInfo: {
    title: 'Lemesh',
    meta: [
      {
        name: 'keywords',
        content: '小米IoT,米家智能,天猫精灵,全屋智能,智慧酒店,智慧公寓,智能商业照明,百度智能,华为智能,华为hilink,无主灯智能,无线智能,蓝牙mesh智能,去中心化无线智能,物联模组,WiFi',
      },
      {
        name: 'description',
        content: '乐式科技，专业家居商业照明解决方案，天猫小米IoT平台服务商，国内行业智慧物联解决方案IoT平台',
      },
    ],
  },
  name: 'saas',
  components: { Button, Carousel, CarouselItem },
  data() {
    return {
      isMobile: _isMobile(),
      isWeChat: _isWeChat(),
      lists: [],
      show: false,
      bodyWidth: 0,
      cases: [
        require('./resources/case00.jpg'),
        require('./resources/case01.jpg'),
        require('./resources/case02.jpg'),
        require('./resources/case03.jpg'),
        require('./resources/case04.jpg'),
        require('./resources/case05.jpg'),
        require('./resources/case06.jpg'),
        require('./resources/case07.jpg'),
        require('./resources/case08.jpg'),
        require('./resources/case09.jpg'),
        require('./resources/case10.jpg'),
      ],
      screen05: [
        { title: '天猫精灵 H5', subtitle: '提供SigMesh模组 <br/> 及产测工具', url: '' },
        { title: '小米IoT H5', subtitle: '提供小米SigMesh模组、WiFi模组 <br/> 及产测工具', url: '' },
        { title: '京东智能H5', subtitle: '提供京东WiFi模组 <br/> 及产测工具', url: '' },
        { title: '华为智能H5', subtitle: '提供SigMesh、WiFi模组 <br/> 及产测工具', url: '' },
      ],
    };
  },
  async mounted() {
    this.bodyWidth = document.body.clientWidth;

    let response = await getAppLists();
    this.lists = response;
  },
  methods: {
    onClick(url) {
      if (this.isWeChat) {
        this.show = true;
      } else {
        location.href = url;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
